import { useEffect } from 'react';

type ReCAPTCHAProps = {
  action: string;
};

const ReCAPTCHA = ({ action }: ReCAPTCHAProps) => {
  useEffect(() => {
    const executeReCAPTCHA = () => {
      if ('grecaptcha' in window) {
        (window as any).grecaptcha.execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, { action });
      }
    };

    if (typeof window !== 'undefined') {
      if ('grecaptcha' in window) {
        executeReCAPTCHA();  // Execute reCAPTCHA if grecaptcha is already available
      } else {
        // Load the reCAPTCHA script if it's not already loaded
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
          executeReCAPTCHA();  // Execute reCAPTCHA after the script is loaded
        };
      }
    }
  }, [action]);

  return null;
};

export default ReCAPTCHA;
